var MINUTE = 60;
var HOUR = MINUTE * 60;
var DURATION_PREFIX = 'PT';

var getValueWithSufix = function getValueWithSufix(value, period) {
  if (!value) return '';
  return "".concat(value).concat(period);
};

var durationToISO = function durationToISO(duration) {
  var fullHours = Math.trunc(duration / HOUR);
  var fullMinutes = Math.trunc((duration - fullHours * HOUR) / MINUTE);
  var fullSeconds = Math.trunc(duration - fullHours * HOUR - fullMinutes * MINUTE);
  var hours = getValueWithSufix(fullHours, 'H');
  var minutes = getValueWithSufix(fullMinutes, 'M');
  var seconds = getValueWithSufix(fullSeconds, 'S');
  return "".concat(DURATION_PREFIX).concat(hours).concat(minutes).concat(seconds);
};

export default durationToISO;